// Markdown mínimo y seguro para las respuestas de Aurora IA: todo se escapa antes de agregar etiquetas.

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function inline(text) {
  return escapeHtml(text)
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/(^|[^*])\*([^*\s][^*]*)\*/g, '$1<em>$2</em>');
}

function splitRow(line) {
  return line.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map((c) => c.trim());
}

const isSeparatorRow = (cells) => cells.every((c) => !c || /^:?-{2,}:?$/.test(c));

/** Filas de la primera tabla Markdown del texto (para insertarla en una hoja). */
export function markdownTableRows(md) {
  const lines = String(md || '').split('\n');
  const rows = [];
  for (const line of lines) {
    if (line.trim().startsWith('|')) {
      const cells = splitRow(line);
      if (!isSeparatorRow(cells)) rows.push(cells.map((c) => (c !== '' && !Number.isNaN(Number(c)) ? Number(c) : c)));
    } else if (rows.length) {
      break;
    }
  }
  return rows;
}

export function markdownToHtml(md) {
  const lines = String(md || '').replace(/\r/g, '').split('\n');
  const out = [];
  let list = null; // 'ul' | 'ol'
  const closeList = () => {
    if (list) out.push(`</${list}>`);
    list = null;
  };

  for (let i = 0; i < lines.length; i += 1) {
    const line = lines[i];
    const trimmed = line.trim();
    if (!trimmed) {
      closeList();
      continue;
    }
    if (trimmed.startsWith('|')) {
      closeList();
      const rows = [];
      while (i < lines.length && lines[i].trim().startsWith('|')) {
        const cells = splitRow(lines[i]);
        if (!isSeparatorRow(cells)) rows.push(cells);
        i += 1;
      }
      i -= 1;
      if (rows.length) {
        const [head, ...body] = rows;
        out.push(
          '<table><thead><tr>' + head.map((c) => `<th>${inline(c)}</th>`).join('') + '</tr></thead><tbody>'
          + body.map((r) => '<tr>' + r.map((c) => `<td>${inline(c)}</td>`).join('') + '</tr>').join('')
          + '</tbody></table>',
        );
      }
      continue;
    }
    const heading = trimmed.match(/^(#{1,6})\s+(.*)$/);
    if (heading) {
      closeList();
      const level = Math.min(heading[1].length + 1, 4); // # → h2: el título del archivo ya es el nombre
      out.push(`<h${level}>${inline(heading[2])}</h${level}>`);
      continue;
    }
    const bullet = trimmed.match(/^[-*•]\s+(.*)$/);
    const numbered = trimmed.match(/^\d+[.)]\s+(.*)$/);
    if (bullet || numbered) {
      const kind = bullet ? 'ul' : 'ol';
      if (list !== kind) {
        closeList();
        out.push(`<${kind}>`);
        list = kind;
      }
      out.push(`<li>${inline((bullet || numbered)[1])}</li>`);
      continue;
    }
    closeList();
    if (trimmed.startsWith('>')) {
      out.push(`<blockquote>${inline(trimmed.replace(/^>\s?/, ''))}</blockquote>`);
    } else {
      out.push(`<p>${inline(trimmed)}</p>`);
    }
  }
  closeList();
  return out.join('');
}
